import { TFormatStore } from "../../wrappers/StoreLocatorWrapper/StoreLocatorUtils/StoreLocatorUtils";

export type TStoresFormatted = {
  lat: number;
  lng: number;
  name?: string;
  distance?: number;
  pin: string;
};

type TStoreDistance = TFormatStore & {
  distance?: number;
};

const selectPin = (division: string) => {
  if (division === "John Lewis") {
    return "/icons/jl-map-pin.svg";
  } else if (division === "Waitrose") {
    return "/icons/waitrose-map-pin.svg";
  } else if (division === "Booths") {
    return "/icons/booths-map-pin.svg";
  }
  return "/icons/location-icon.svg";
};

export const mapFormatStores = (
  stores: TStoreDistance[]
): TStoresFormatted[] => {
  return stores.map((store) => ({
    lat: store.coordinates.lat,
    lng: store.coordinates.lng,
    name: `${store.division} ${store.branchName}`,
    ...(store.distance !== undefined && { distance: store.distance }),
    pin: selectPin(store.division),
  }));
};
